module.exports = __webpack_public_path__ + "img/dry-hairy-tree-05.1d3af7bd.png";